import React from "react";
import Box from "./Box";

function Spinner() {
  return (
    <Box display="flex" justifyContent="center">
      <div className="rs-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </Box>
  );
}

export default Spinner;
